// New routes implementation for BASIC project
// Uses the new route factory system
import React from 'react'
import { ProjectRoutes } from './routeFactory'
import { getProjectRouteConfig } from './projectRoutesRegistry'

const RoutesForBasicNew = ({
	isLogged,
	isLoggingIn
}) => {
	// Get project configuration
	const config = getProjectRouteConfig('BASIC')

	if (!config) {
		// This should never happen if project is properly registered
		console.error('BASIC route config not found in projectRoutesRegistry')
		return null
	}

	// Use new route factory component directly
	return <ProjectRoutes config={config} isLogged={isLogged} isLoggingIn={isLoggingIn} />
}

export default RoutesForBasicNew
